import { cx } from "@/components/ui";

/**
 * Stripe's official "Powered by Stripe" badge (stripe.com/newsroom/brand-assets; blurple, Stripe's
 * colour for light backgrounds, linked to stripe.com as Stripe asks). Shown next to anything that
 * takes a card, and only while Stripe is the processor — never for the simulated test processor.
 */
export function PoweredByStripe({
  provider,
  className,
}: {
  provider: string | undefined;
  className?: string;
}) {
  if (provider !== "stripe") return null;
  return (
    <a
      href="https://stripe.com"
      target="_blank"
      rel="noreferrer"
      className={cx("inline-flex w-fit shrink-0 rounded-[5px]", className)}
    >
      <img
        src="/brand/powered-by-stripe-blurple.svg"
        alt="Powered by Stripe"
        width={150}
        height={34}
        className="block h-[34px] w-[150px] max-w-none"
      />
    </a>
  );
}
